import apiService from '@/services/apiService';

const actions = {
  getTncCategorys({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('tnc-category/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getTncCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`tnc-category/${payload}`)
        .then((response) => {
          resolve(response.data.data);
          commit('getTncCategory', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  orderTncCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`tnc-category/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postTncCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('tnc-category', payload)
        .then((response) => {
          commit(`postTncCategory${payload.interface}`, payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putTncCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`tnc-category/${payload.id}`, payload.formData)
        .then((response) => {
          // commit(`putTncCategory${payload.tncData.interface}`, payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delTncCategory({ commit }, payload) {
    apiService.delete(`tnc-category/${payload.id}`)
      .then((response) => {
        // commit(`delTncCategory${payload.interface}`, payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
